import BoxRendererType from '@jbrowse/core/pluggableElementTypes/renderers/BoxRendererType';
import Plugin from '@jbrowse/core/Plugin';
import { configSchema as svgFeatureRendererConfigSchema, ReactComponent as SvgFeatureRendererReactComponent, } from './SvgFeatureRenderer';
class SvgFeatureRenderer extends BoxRendererType {
    constructor() {
        super(...arguments);
        this.supportsSVG = true;
    }
}
export default class SVGPlugin extends Plugin {
    constructor() {
        super(...arguments);
        this.name = 'SVGPlugin';
    }
    install(pluginManager) {
        pluginManager.addRendererType(() => new SvgFeatureRenderer({
            name: 'SvgFeatureRenderer',
            ReactComponent: SvgFeatureRendererReactComponent,
            configSchema: svgFeatureRendererConfigSchema,
            pluginManager,
        }));
    }
}
export { configSchema as svgFeatureRendererConfigSchema, ReactComponent as SvgFeatureRendererReactComponent, } from './SvgFeatureRenderer';
